export default class BudgetListModes {
	static DASHBOARD = 'BUDGET_LIST_MODE_DASHBOARD';
	static TYPES = 'BUDGET_LIST_MODE_TYPES';
	static AMOUNTS = 'BUDGET_LIST_MODE_AMOUNTS';
}
